import React, { useEffect, useState } from 'react';
import { useQuoteApi } from '../../../app/api/quote';
import CRMFastRateFrame from './CRMFastRateFrame';
import FormLoadingScreen from '../../../components/ui/loaders/FormLoadingScreen/FormLoadingScreen';
import { isAxiosError } from 'axios';
import { ResponseResultCode } from '../../../app/enums/ResponseResultCode';
import { IError } from '../../../app/interfaces/response/IResponse';

const CRMFastRate: React.FC = () => {

    const [model, setModel] = useState<string | null>(null);

    const [errors, setErrors] = useState<Array<IError>>([]);
    const {
        getQuoteCmrFastRateLink: {
            query: getQuoteCmrFastRateLink,
            isLoading: getQuoteCmrFastRateLinkIsLoading,
            cancel: cancelGetQuoteCmrFastRateLink
        }
    } = useQuoteApi();

    useEffect(() => {
        (async () => {
            try {
                const response = await getQuoteCmrFastRateLink();
                if (response?.status === 200 && response.data && response.data.data && response.data.data) {
                    setModel(response.data.data);
                }
            } catch (err) {
                        if (isAxiosError(err)) {
                            if (err.response && err.response.data && err.response.status === 422 &&
                                err.response.data.resultCode === ResponseResultCode.NotValidData &&
                                err.response.data.errors && Array.isArray(err.response.data.errors)) {
                                setErrors(err.response.data.errors);
                            }
                        }
                    }
        })();

        return () => {
            cancelGetQuoteCmrFastRateLink();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (getQuoteCmrFastRateLinkIsLoading) {
        return (
            <FormLoadingScreen height={`200px`} style={{padding: '5px'}}/>
        )
    }

    return (<CRMFastRateFrame model={model} errors={errors}/>);
};

export default CRMFastRate;

